// extracted by mini-css-extract-plugin
module.exports = {"relateNewsScroll":"index-module_relateNewsScroll_2Qsjo"};